// Returns an i18n key, not display text — callers wrap with t().
export const timeGreetingKey = (hour: number): string => {
  if (hour < 12) return "Good morning";
  if (hour < 18) return "Good afternoon";
  return "Good evening";
};
